export default __webpack_public_path__ + "static/media/header-backround.7fbe2678.jpg";